<template>
	<div id="enterprise_detail">
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
		<div class="index_left_centerpage">
		<div class="enterprise_detail">
			<div class="whitebox " :class="userdata.userType == 2?'centerpage':''"> 
				<div class="d_blocktitle">
					<i class="title-icon title-icon1"></i>
					<h3 class="ctitle">{{companyinfor.title}}</h3> 
					<!-- <span v-if="companyinfor.fullName!=''">（{{companyinfor.fullName}}）</span> -->
					
				</div>
				<ul class="oh conpany-infor-new">
					<li class="inforLine inforLine-one"><span class="label">场景类别：</span><span class="infortext">{{companyinfor.type}}</span> </li>
					<li class="inforLine inforLine-one"><span class="label">场景需求：</span><span class="infortext">{{companyinfor.requirment}}</span> </li>
					<li class="inforLine inforLine-one"><span class="label">建设基础：</span><span class="infortext">{{companyinfor.basis}}</span> </li>
					<li class="inforLine inforLine-one"><span class="label" style="width: 160px;">业主单位/申报单位：</span><span class="">{{companyinfor.declaringUnit}}</span> </li>
					<li class="inforLine inforLine-one"><span class="label">联系人及电话：</span><span class="infortext">{{companyinfor.phone}}</span> </li>
					<li class="inforLine inforLine-one"><span class="label">省份：</span><span class="infortext">{{companyinfor.province}}</span> </li>
					<li class="inforLine inforLine-one"><span class="label">城市：</span><span class="infortext">{{companyinfor.city}}</span> </li>
					<li class="inforLine inforLine-one"><span class="label">邮箱：</span><span class="infortext">{{companyinfor.email}}</span> </li>
				</ul> 
			</div>
		</div>
		</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";
	export default {
		name: 'institutionDetail',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				curindex: 5,
				searchtype:6,enterpriseWebsite:"",
				guidepage:'境外上市企业详情页',echartWidth2:document.body.offsetWidth*0.8728*0.95*0.48,
				userdata:{},othertransList:[],conditionBar1Data:{value:[0,0,0,0],noEmpty1:false},conditionBar2Data:{value:[0,0,0,0],noEmpty1:false,},
				enterpriseid: 0,profitData:{date:[],list:[],unit:""},debtData:{date:[],list:[],unit:""},cashData:{date:[],list:[],unit:""},
				companyinfor: {title:"",industry:"",block:"", certificatetype:'','insurePerson':0,summary:"",adress:"",phone:"",website:"",portno:""}, 
				floorlist: ['联系方式', '投资领域','投资事件'], 
				rwebsite:false,barHeight:60,
			}
		},  
		beforeCreate() {
				
		},
		created() {
			this.$nextTick(() => {
					// 禁用右键
					document.oncontextmenu = new Function("event.returnValue=false");
					// 禁用选择
					document.onselectstart = new Function("event.returnValue=false");
			}); 
			// window.scrollTo(0,0);
			this.bus.$emit('loading',true);
			this.enterpriseid = this.$route.query.id; 
			var _this=this;
			this.userdata = this.getuseriformation();
			
		},
		mounted() {
			window.scrollTo(0, 0);  
			this.getDetails();
			
		},
		methods: { 
            getDetails(){
                var _this=this;
                let ajaxurl = this.$api.cyl.appScene.detail()+'?id='+this.enterpriseid;
                this.$axios.get(ajaxurl, {
                    headers: {
                        AuthToken: this.userdata.token
                    },
                }).then((res) => {
                    if (res.data.success) {
                        this.companyinfor = res.data.data;
						document.title = this.companyinfor.title;
                    }
                })
            },
		//判断企业网址是否符合标准 长度大于4并且要有http
		getEnterpriseWebsite(str){
			// console.log('str',str)
			if(str.length>3){
				if(str.indexOf('http')<0){
					str='http://'+str;
				}  
			}
			this.enterpriseWebsite=str; 
		}, 
			//添加删除收藏
			collectFun(){
				// console.log(this.companyinfor.collectId,this.companyinfor);
				this.listToggleCollect(this.companyinfor,'acoc') 
			},
 
			//企业网址跳转
			geturl(url) {  
				if(url.indexOf('http')<0){
					url='http://'+url;
				}
				window.open(url);
				},
		}
	}
</script>

<style scoped>
.whitebox {
	min-height: 86vh;
	}
	.enterprise_table{
		margin-bottom: 50px;
	}
	.endsm_title{
		border-left:8px solid #3e7bfa;line-height: 20px; padding-left:14px;margin: 10px 0 30px;
	}
</style> 
